import icon from './Icon.png';

const WidgetIcon = (props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => <img alt='Chat icon' {...props} src={icon} />;

export { WidgetIcon };
